import { render, staticRenderFns } from "./materialInputPriceViewTable.vue?vue&type=template&id=e104e954&scoped=true&"
import script from "./materialInputPriceViewTable.vue?vue&type=script&lang=js&"
export * from "./materialInputPriceViewTable.vue?vue&type=script&lang=js&"
import style0 from "./materialInputPriceViewTable.vue?vue&type=style&index=0&id=e104e954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e104e954",
  null
  
)

export default component.exports